import React from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primeicons/primeicons.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { BrowserRouter } from "react-router-dom";
import { Config } from "./config/config";
import { AppRoutes } from "./routes/AppRoutes";
import { ApplicationProvider } from "./application/ApplicationContext";
import Application from "./application/Application";
import "./App.css";
import { Provider } from "react-redux";
import store from "./store-redux/store";

const App = () => {
  return (
    <Provider store={store}>
      <ApplicationProvider>
        <Application>
          <div className="uos-portal-app">
            <BrowserRouter basename={Config.baseFolder}>
              <AppRoutes />
            </BrowserRouter>
          </div>
        </Application>
      </ApplicationProvider>
    </Provider>
  );
};

export default App;
